<template>
  <v-card class="mx-auto" color="transparent" elevation="0">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">{{title}}</v-list-item-title>
        <v-list-item-subtitle>{{subtitle}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: "Header",
  props: ["title", "subtitle"],
  computed: {},

  created() {},

  methods: {}
};
</script>
